<style lang="less" scoped>
/deep/.el-tabs__nav>.el-tabs__item{padding: 0px !important;}
/deep/.el-tabs__item {width: 120px;font-size: 14px;padding: 0px;}
</style>

<template>
  <div>
    <el-tabs v-model="editableTabsValue" type="card">
      <el-tab-pane label='参会信息' name='1'>
        <Information :userdata='userdata'></Information>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/**
 * 李旭
 * 参会信息
 */
import Information from './Information'
import {mapState} from 'vuex'
export default {
  props: ['userData'],
  components: {
    Information
  },
  data()
  {
    return {
      editableTabsValue: '1',
      userdata: this.userData
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        this.editableTabsValue = nval
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/chxx/Chxx.vue